import { render, staticRenderFns } from "./TestInt.vue?vue&type=template&id=22c7366a"
import script from "./TestInt.vue?vue&type=script&lang=js"
export * from "./TestInt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports